"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _cuid = _interopRequireDefault(require("cuid"));
var ExclamationTriangle = function ExclamationTriangle(props) {
  var uniqueId = (0, _cuid["default"])();
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({
    uniqueId: uniqueId
  }, props), /*#__PURE__*/_react["default"].createElement("title", null, "exclamation-triangle"), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.54 15.54l-7.62-13.26c-0.381-0.668-1.089-1.111-1.9-1.111s-1.519 0.443-1.894 1.1l-0.006 0.011-7.62 13.26c-0.187 0.315-0.298 0.695-0.298 1.1 0 1.204 0.976 2.18 2.18 2.18 0.006 0 0.013-0 0.019-0h15.259c1.203-0.001 2.178-0.977 2.178-2.18 0-0.405-0.111-0.785-0.303-1.11l0.006 0.010zM8.82 6.66c0.079-0.593 0.582-1.045 1.19-1.045s1.111 0.453 1.189 1.039l0.001 0.006v4.3c-0.079 0.593-0.582 1.045-1.19 1.045s-1.111-0.453-1.189-1.039l-0.001-0.006zM10 16.42c-0.784 0-1.42-0.636-1.42-1.42s0.636-1.42 1.42-1.42c0.784 0 1.42 0.636 1.42 1.42v0c0 0.784-0.636 1.42-1.42 1.42v0z"
  }));
};
var _default = exports["default"] = ExclamationTriangle;